"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Authenthication = require("./Authentication");
var DeAuthenthication = require("./DeAuthentication");
var SupportedFunction = require("./SupportedFunction");
var Function = require("./Function");
// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
exports.reducers = {
    deAuthentication: DeAuthenthication.reducer,
    authentication: Authenthication.reducer,
    supportedFunction: SupportedFunction.reducer,
    function: Function.reducer,
};
//# sourceMappingURL=index.js.map